<script setup lang="ts">
	import { cn } from '~/utils/functions'
	defineOptions({ inheritAttrs: false })
	const attrs = useAttrs()
	withDefaults(
		defineProps<{
			ui?: {
				width?: string
			}
			tag?: string
		}>(),
		{
			ui: () => ({
				width: 'max-w-[1300px]  xl:max-w-[1500px] mx-auto'
			}),
			tag: 'section'
		}
	)
	const forwardedAttrs = computed(() => {
		const { class: _class, ...rest } = attrs
		return rest
	})
	const className = computed(() => String(attrs.class ?? ''))
</script>
<template>
	<component :is="tag" v-bind="forwardedAttrs" :class="cn(ui.width, className)">
		<slot />
	</component>
</template>
